import React from 'react';

function FilterControl({ id, label, children }) {
  return (
    <div className="form-control">
      <label htmlFor={id}>{label}</label>
      {children}
    </div>
  );
}

function FilterTextInput({ id, name = id, value, onChange }) {
  return (
    <input
      type="text"
      id={id}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
}

function FilterSelect({ id, name = id, value, onChange, options, allLabel }) {
  return (
    <select
      name={name}
      id={id}
      className="normal"
      value={value}
      onChange={onChange}
    >
      <option value="">{allLabel}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

export {
  FilterControl,
  FilterSelect,
  FilterTextInput,
};
